import { Radio } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

export default function BDRadio({
  value,
  children,
  className,
  ...rest
}: {
  value: string;
  children: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  return (
    <Radio
      key={value}
      value={value}
      as="div"
      className={clsx(
        'data-checked:border-bd-primary data-focus:border-bd-primary hover:border-bd-primary border-bd-contrast data-checked:bg-bd-secondary shadow-xs focus:outline-hidden data-checked:m-0 data-checked:border-2 data-disabled:cursor-not-allowed data-focus:m-0 data-focus:border-2 group relative m-[1px] flex cursor-pointer flex-col items-center rounded-md border bg-white p-4 hover:m-0 hover:border-2',
        className
      )}
      {...rest}
    >
      {children}
      <CheckCircleIcon
        aria-hidden="true"
        className="text-bd-primary absolute right-2 top-2 size-5 group-[&:not([data-checked])]:invisible"
      />
    </Radio>
  );
}

export function BDRoundRadio({
  value,
  children,
  className,
  ...rest
}: {
  value: string;
  children: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  return (
    <Radio
      key={value}
      value={value}
      className={clsx(
        'ring-bd-primary focus:outline-hidden data-checked:ring-[2px] data-focus:data-checked:ring-2 data-focus:data-checked:ring-offset-1 group relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5',
        className
      )}
      {...rest}
    >
      {children}
    </Radio>
  );
}

export function BDRulerRadio({
  value,
  children,
  className,
  ...rest
}: {
  value: string;
  children: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  return (
    <Radio
      key={value}
      value={value}
      as="div"
      className={clsx(
        'border-bd-contrast hover:border-bd-primary focus:outline-hidden data-disabled:cursor-not-allowed group relative flex cursor-pointer flex-col items-center justify-end gap-1 border-y border-l bg-white py-4 first:rounded-l-xl last:rounded-r-xl last:border-r hover:border-y-2 hover:border-l-2 focus:border-y-2 focus:border-l-2',
        className
      )}
      {...rest}
    >
      {children}
      <CheckCircleIcon
        aria-hidden="true"
        className="text-bd-primary absolute right-2 top-2 size-5 group-[&:not([data-checked])]:invisible"
      />
    </Radio>
  );
}

export function BDRoundedRadio({
  value,
  image,
  children,
  className,
  ...rest
}: {
  value: string;
  image: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  [key: string]: any;
}) {
  return (
    <Radio
      key={value}
      value={value}
      as="div"
      className={clsx(
        'focus:outline-hidden data-disabled:cursor-not-allowed group flex cursor-pointer flex-col items-center bg-white',
        className
      )}
      {...rest}
    >
      <div className="group-data-checked:border-bd-primary group-data-focus:border-bd-primary border-bd-contrast group-hover:border-bd-primary aspect group-data-checked:m-0 group-data-checked:border-2 group-data-focus:m-0 group-data-focus:border-2 relative m-[1px] box-content aspect-square w-full rounded-full border group-hover:m-0 group-hover:border-2">
        {image}
      </div>
      {children}
    </Radio>
  );
}
